import { useEffect, useState } from "react"

const useOtpResendCooldown = (initialSeconds = 0) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds)

  useEffect(() => {
    if (secondsLeft <= 0) {
      return undefined
    }
    const timer = setInterval(() => {
      setSecondsLeft(current => (current <= 1 ? 0 : current - 1))
    }, 1000)
    return () => clearInterval(timer)
  }, [secondsLeft > 0])

  return [secondsLeft, setSecondsLeft]
}

export const otpRetrySeconds = (response, fallback = 0) => {
  const wait = Number(
    response?.data?.retryAfterSeconds ?? response?.data?.resendAfterSeconds
  )
  if (Number.isFinite(wait) && wait > 0) {
    return wait
  }
  return fallback
}

export const resendButtonLabel = (t, secondsLeft, idleLabel) => {
  if (secondsLeft > 60) {
    return t("Try again in {{minutes}} min", {
      minutes: Math.ceil(secondsLeft / 60),
    })
  }
  if (secondsLeft > 0) {
    return t("Resend OTP in {{seconds}}s", { seconds: secondsLeft })
  }
  return idleLabel
}

export default useOtpResendCooldown
